//// rishab code for state and country
import React, { useEffect, useRef, useState } from "react";
import "./CustomerContactProfile.scss";
import CancelSaveHeader from "../../components/customPageHeader/CancelSaveHeader";
import { useAuth } from "../../contexts/auth";
import defaultProfilePic from "../../assets/profilepic.jpg";
import "../../components/typographyText/styles.scss";
import CustomTextBox from "../../components/customTextBox/CustomTextBox";
import CustomChangePwdPopup from "../../components/customPopup/CustomChangePwdPopup";
import { LoadPanel, SelectBox, TextBox } from "devextreme-react";
import { ToastDisplayer } from "../../components/toastDisplay/ToastDisplayer";
import { generateOtpWithAction } from "../../api/forgotPwdApi";
import {
  editCustApi,
  getCountryState,
  getCustomerContactProfileData,
  requestAddressFromPin,
  updateContactLogo,
} from "../../api/companyCustomerApi";
import { useNavigate, useLocation } from "react-router-dom";
import { data } from "framer-motion/client";

export default function CustomerContactProfile() {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  const [isProflePopupVisible, setisProflePopupVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [image, setImage] = useState();
  const [dispimage, setDispImage] = useState();
  const [loading, setLoading] = useState(false);
  const [cmpCustomerData, setCmpCustomerData] = useState();
  const custCountryRef = useRef();
  const [pinCodeRect, setPinCodeRect] = useState(true);

  const [formData, setFormData] = useState({
    registeredAddress: "",
    city: "",
    pinCode: "",
    contactNumber: "",
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);

  const projectRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.section === "projects" && projectRef.current) {
      setTimeout(() => {
        projectRef.current.scrollIntoView({ behavior: "smooth" });
      }, 300); // slight delay to ensure rendering
    }
  }, [location]);

  // Fetch countries on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        setLoading(true);
        const response = await getCountryState();
        const countriesList = response.data.map((country) => ({
          text: country.name,
          value: country.name,
          states: country.states, // Include states for later use
        }));
        setCountries(countriesList);
      } catch (error) {
        ToastDisplayer("error", error?.response?.data?.msg);
      } finally {
        setLoading(false);
      }
    };
    fetchCountries();
  }, []);

  // Fetch states based on the selected country
  useEffect(() => {
    if (selectedCountry) {
      const countryData = countries.find(
        (country) => country.value === selectedCountry,
      );
      if (countryData) {
        const stateList = countryData.states.map((state) => ({
          text: state.name,
          value: state.name,
        }));
        setStates(stateList);
      }
    }
  }, [countries, selectedCountry]);

  useEffect(() => {
    const fetchCustomer = async () => {
      // console.log("User : ", user);
      if (user) {
        try {
          setLoading(true);
          const result = await getCustomerContactProfileData(user?.contactcode);
          if (result.status === 200) {
            // console.log("Result Data for Contact : ", result?.data?.data);
            setFormData(result?.data?.data);
            custCountryRef.current = result?.data?.data?.customer?.custcountry;
            setCmpCustomerData(result?.data?.data);
          }
        } catch (error) {
          ToastDisplayer(
            "error",
            error.response?.data?.error || "An unexpected error occurred.",
          );
        } finally {
          setLoading(false);
        }
      }
    };

    fetchCustomer();
  }, []);

  const [errors, setErrors] = useState({});

  // We have to change this for Customer Contact Form
  // const validateForm = () => {
  //   const newErrors = {};

  //   if (!formData.contactNumber) {
  //     newErrors.contactNumber = "Contact number is required.";
  //   } else if (!/^\d{3,15}$/.test(formData.contactNumber)) {
  //     newErrors.contactNumber =
  //       "Contact number must be numeric and must be between 3 to 15";
  //   }

  //   if (!formData.registeredAddress)
  //     newErrors.registeredAddress = "Address is required.";

  //   if (!formData.city) newErrors.city = "City is required.";

  //   if (!formData.pinCode) {
  //     newErrors.pinCode = "Pin code is required.";
  //   } else if (!/^\d{6}$/.test(formData.pinCode)) {
  //     newErrors.pinCode = "Pin code must be 6 digits.";
  //   } else if (!pinCodeRect)
  //     newErrors.pinCode = "Please enter a valid pincode!";

  //   if (!formData.country) newErrors.country = "Country is required.";

  //   if (!formData.state) newErrors.state = "State is required.";

  //   setErrors(newErrors);
  //   Object.values(newErrors).forEach((error) => {
  //     ToastDisplayer("error", error);
  //   });
  //   return Object.keys(newErrors).length === 0;
  // };

  const handleImageClick = (e) => {
    e.preventDefault();
    document.getElementById("profileImage").click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    // setDispImage(file);
    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result.split(",")[1];
        setImage(reader.result);
        setDispImage(base64String);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleImageHover = (isHovering) => {
    setIsHovered(isHovering);
  };

  const handleInputChange = (name) => (e) => {
    const value = e.value;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // We have to change this for Customer Contact Form
  const handleProfileSaveDetails = async () => {
    if (!dispimage) {
      ToastDisplayer("error", "Please select an image first");
      return;
    }

    try {
      setLoading(true);

      const result = await updateContactLogo(dispimage);

      if (result.success) {
        setUser((prevUser) => ({
          ...prevUser,
          contactlogo: dispimage,
        }));

        const getSess = JSON.parse(sessionStorage.getItem("authState")) || {};
        const updSess = { ...getSess, contactlogo: dispimage };
        sessionStorage.setItem("authState", JSON.stringify(updSess));

        ToastDisplayer("success", result.message);
      } else {
        ToastDisplayer("error", result.message);
      }
    } catch (error) {
      ToastDisplayer("error", error.message);
    } finally {
      setLoading(false);
    }
  };

  const toggleProfileOtpPopup = async () => {
    try {
      setLoading(true);

      const otpResult = await generateOtpWithAction(user.email, "R");
      ToastDisplayer(
        otpResult?.status === 200 ? "success" : "error",
        otpResult?.status === 200
          ? otpResult.data.message
          : "OTP generation failed",
      );

      setisProflePopupVisible(!isProflePopupVisible);
    } catch (error) {
      ToastDisplayer("error", error.response?.data?.error || error.message);
    } finally {
      setLoading(false);
    }
  };

  const toggleProfileCloseFromPopup = async () => {
    setisProflePopupVisible(!isProflePopupVisible);
  };

  //// trying to display customer logo
  useEffect(() => {
    if (user?.contactlogo) {
      setImage(`data:image/jpeg;base64,${user?.contactlogo}`);
    } else {
      setImage("");
    }
  }, [user]);

  const handleCancel = () => {
    navigate(-1);
  };

  const handleGetAddress = async (pinCode) => {
    setLoading(true);
    if (pinCode.length === 6) {
      const getAddress = await requestAddressFromPin(pinCode);
      if (getAddress[0].Status === "Success") {
        setPinCodeRect(true);
        const add = getAddress[0].PostOffice[0];
        setFormData((prev) => {
          return {
            ...prev,
            country: add.Country,
            state: add.State,
            city: add.District,
          };
        });
      } else {
        setPinCodeRect(false);
      }
    }
    setLoading(false);
  };

  const handleSelectBoxChange = (field) => {
    return (e) => {
      const newValue = e.value;
      setFormData((prev) => {
        return {
          ...prev,
          [field]: newValue,
        };
      });
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: undefined,
      }));
    };
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getStatusBadge = (endDate) => {
    if (!endDate) return { label: "Unknown", color: "unknown" };

    const diff = Math.ceil(
      (new Date(endDate) - new Date()) / (1000 * 60 * 60 * 24),
    );

    if (diff < 0) return { label: "Expired", color: "expired" };
    if (diff <= 15) return { label: `Expires in ${diff}d`, color: "warning" };

    return {
      label: `Expires in ${diff} day${diff > 1 ? "s" : ""}`,
      color: "active",
    };
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div className="ProfilePage">
        <CancelSaveHeader
          titleName={"Contact Profile"}
          handleDetCancel={handleCancel}
          handleDetSave={handleProfileSaveDetails}
        />
        {/* <div className="profileHeader">Contact Profile</div> */}
        <div className="profileMain">
          <div className="mainProfileSection">
            <div className="profileUpper">
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div
                  className={`user-image-container ${isHovered ? "hovered" : ""}`}
                  onMouseEnter={() => handleImageHover(true)}
                  onMouseLeave={() => handleImageHover(false)}
                >
                  <label htmlFor="profileImage">
                    <img src={image || defaultProfilePic} alt="Profile" />
                  </label>
                  {isHovered && (
                    <div className="hover-icon" onClick={handleImageClick}>
                      <i className="ri-user-add-line"></i>
                    </div>
                  )}
                  <input
                    type="file"
                    id="profileImage"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                  />
                </div>
                <div className="profileContent">
                  <div className="typ-header-text">
                    {user?.username || user?.email?.split("@")[0] || "Username"}
                  </div>
                  <div className="typ-sub-text">
                    <span style={{ fontWeight: 600 }}>Email ID </span>:{" "}
                    {user?.email}
                  </div>
                  <div
                    className="custom-profile-text"
                    onClick={toggleProfileOtpPopup}
                  >
                    Change Password
                  </div>
                </div>
              </div>

              <div className="container1">
                <div className="profileContent">
                  <div className="typ-sub-text">
                    <span style={{ fontWeight: 600 }}>
                      Company Contact Code
                    </span>{" "}
                    : {cmpCustomerData?.contactcode}
                  </div>
                </div>
                <div className="profileContent">
                  <div className="typ-sub-text">
                    <span style={{ fontWeight: 600 }}>Contact Number</span> :{" "}
                    {cmpCustomerData?.contactnumber}
                  </div>
                </div>
              </div>
              <div className="container2">
                <div className="profileContent">
                  <div className="typ-sub-text">
                    <span style={{ fontWeight: 600 }}>
                      Company Contact Name
                    </span>{" "}
                    : {cmpCustomerData?.contactname}
                  </div>
                </div>
                <div className="profileContent">
                  <div className="typ-sub-text">
                    <span style={{ fontWeight: 600 }}>Department</span> :{" "}
                    {cmpCustomerData?.departmentname
                      ? cmpCustomerData?.departmentname
                      : "--"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="editProfileSection">
            <div className="lowerSecHeader">
              <div className="detail-small-light">Company Information</div>
            </div>
            <div className="lowerSecProfile">
              <CustomTextBox
                label="Company Name"
                placeholder="Company Name"
                value={formData?.customer?.custname}
                // onChange={handleInputChange("contactNumber")}
                type="text"
                readOnly
              />

              <CustomTextBox
                label="Company Email"
                placeholder="Company Email"
                value={formData?.customer?.custemail}
                // onChange={handleInputChange("registeredAddress")}
                type="text"
                readOnly
              />

              {/* <CustomTextBox
                label="Pin Code"
                placeholder="Pin Code"
                value={formData.pinCode}
                onChange={handleInputChange("pinCode")}
                type="text"
              /> */}
              {/* <div className="MyTextBox">
                <label className="TextBoxLabel">
                  Pin Code <span className="requiredClass">*</span>
                </label>
                <div className="TextBoxWrapper">
                  <TextBox
                    stylingMode="outlined"
                    className="TextBoxMain"
                    value={formData?.pinCode}
                    onValueChange={handleGetAddress}
                    onValueChanged={handleInputChange("pinCode")}
                    placeholder="Enter Pin Code"
                  />
                </div>
              </div> */}

              <CustomTextBox
                label="City"
                placeholder="City"
                value={formData?.customer?.custcity}
                // onChange={handleInputChange("city")}
                type="text"
                readOnly
              />

              <CustomTextBox
                label="State"
                placeholder="State"
                value={formData?.customer?.custstate}
                // onChange={handleInputChange("state")}
                type="text"
                readOnly
              />

              <CustomTextBox
                label="Country"
                placeholder="Country"
                value={formData?.customer?.custcountry}
                // onChange={handleInputChange("country")}
                type="text"
                readOnly
              />

              {/* <div className="MyDropDown">
                <label className="ddLabel">
                  Country
                  <span className="requiredClass">*</span>
                </label>
                <div className="ddWrapper">
                  <SelectBox
                    className="ddMain"
                    stylingMode="outlined"
                    placeholder="Select Country"
                    items={countries}
                    value={formData?.country}
                    displayExpr="value"
                    onValueChanged={handleSelectBoxChange("country")}
                    // onValueChanged={handleInputChange("country")}
                    valueExpr="value"
                  />
                </div>
              </div> */}

              {/* <CustomDropdown
                label="Country"
                placeholder={formData.country}
                myDataSource={countries}
                setSelectedValue={handleInputChange("country")}
              />
 
              <CustomDropdown
                label="State"
                placeholder={
                  formData.state === "" ? "Select State" : formData.state
                }
                myDataSource={states}
                setSelectedValue={handleInputChange("state")}
              /> */}
            </div>
          </div>

          <div className="projectSection" ref={projectRef}>
            <div className="detail-small-light">Assigned Projects</div>
            <div className="lowerSecProfile">
              {cmpCustomerData?.assigned_projects?.length > 0 ? (
                cmpCustomerData.assigned_projects.map((category, index) => (
                  <div key={index} className="categoryBlock">
                    <div className="categoryTitle">
                      {category.category_name}
                    </div>

                    <div className="subcategoryList">
                      {category.subcategories.map((sub, subIndex) => {
                        const dates = {
                          start: sub.access_start,
                          end: sub.access_deadline,
                        };

                        const status = getStatusBadge(dates?.end);

                        return (
                          <div key={subIndex} className="subcategoryItem">
                            <div className="subcat-left">
                              <span className="subcat-dot" />
                              <span className="subcat-name">
                                {sub.ticketsubcatname}
                              </span>
                            </div>

                            <div className="subcat-right">
                              <div className="date-chip">
                                <i className="ri-play-circle-line" />
                                <span className="date-label">Start</span>
                                <span className="date-value">
                                  {formatDate(dates?.start)}
                                </span>
                              </div>

                              <div className="date-chip">
                                <i className="ri-stop-circle-line" />
                                <span className="date-label">End</span>
                                <span className="date-value">
                                  {formatDate(dates?.end)}
                                </span>
                              </div>

                              <div
                                className="expiryBadge"
                                style={{ width: 100 }}
                              >
                                <span
                                  className={`status-badge ${status.color}`}
                                >
                                  {status.label}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {/* {category.subcategories.map((sub, subIndex) => (
                        <div key={subIndex} className="subcategoryItem">
                          • {sub.ticketsubcatname}
                        </div>
                      ))} */}
                    </div>
                  </div>
                ))
              ) : (
                <div className="detail-mid-light">No Projects Assigned</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <CustomChangePwdPopup
        visible={isProflePopupVisible}
        loading={loading}
        setLoading={setLoading}
        onClose={toggleProfileCloseFromPopup}
      />
    </>
  );
}
